import { useState } from 'react';

export interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: { items: FaqItem[]; defaultOpen?: number }) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.q}
            className={`rounded-2xl border transition-colors duration-300 ${
              isOpen ? 'border-primary-300 bg-background-100' : 'border-background-200 bg-background-100'
            }`}
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 md:py-5 cursor-pointer"
            >
              <span className="text-sm md:text-base font-medium text-foreground-950 leading-relaxed">{item.q}</span>
              <span
                className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-lg transition-colors ${
                  isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-700'
                }`}
              >
                <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ease-out ${
                isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}